"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageDetailsLayout = exports.PageDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var link_value_1 = require("./link-value");
var content_title_1 = require("../elements/content-title");
var slice_layout_1 = require("./slice-layout");
var file_asset_value_1 = require("./file-asset-value");
var entity_linked_items_grid_1 = require("./entity-linked-items-grid");
var markdown_1 = require("../elements/markdown");
exports.PageDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitlesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", " 2px;\n    ", ";\n  "], ["\n    padding: ", " 2px;\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG_END()),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(20))
});
var PretitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 300;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('text'))
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    padding: ", " 0 ", ";\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('text'))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding: ", " 2px 0;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "], ["\n    padding: ", " 2px 0;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(16), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark')),
  tablet: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    padding: ", " ", " 0;\n    font-size: ", ";\n  "], ["\n    padding: ", " ", " 0;\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(18))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "], ["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "])), theme_1.theme.UNIT(3))
});
var SliceStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0 ", ";\n  "], ["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0 ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var OutroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ChildrenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    padding-bottom: 0;\n    margin-top: ", ";\n  "], ["\n    padding-bottom: 0;\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Slice: (0, styled_components_1.default)(slice_layout_1.SliceLayout)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), SliceStyles),
  Titles: styled_components_1.default.header(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Pretitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Children: (0, styled_components_1.default)(entity_linked_items_grid_1.EntityLinkedItemsGrid)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ChildrenStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Outro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var PageDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var content = entity.content,
    _a = entity.slices,
    slices = _a === void 0 ? [] : _a,
    pretitle = entity.pretitle,
    title = entity.title,
    type = entity.type,
    subtitle = entity.subtitle,
    layout = entity.layout,
    intro = entity.intro,
    outro = entity.outro,
    path = entity.path,
    parent = entity.parent,
    _b = entity.featurePages,
    featurePages = _b === void 0 ? [] : _b,
    _c = entity.marqueePages,
    marqueePages = _c === void 0 ? [] : _c,
    _d = entity.feedEntries,
    feedEntries = _d === void 0 ? [] : _d,
    _e = entity.people,
    people = _e === void 0 ? [] : _e,
    _f = entity.authors,
    authors = _f === void 0 ? [] : _f,
    _g = entity.files,
    files = _g === void 0 ? [] : _g,
    _h = entity.children,
    children = _h === void 0 ? [] : _h,
    _j = entity.sites,
    sites = _j === void 0 ? [] : _j;
  var hasLayout = !!layout;
  var hasType = !!type;
  var hasFeaturePages = !!featurePages.length;
  var hasMarqueePages = !!marqueePages.length;
  var hasPeople = !!people.length;
  var hasChildPages = !!children.length;
  var hasSites = !!sites.length;
  var hasSlices = !!slices.length;
  var hasAside = asideHeader || asideFooter || parent || hasType || hasLayout || hasSites || hasChildPages || hasFeaturePages || hasMarqueePages || hasPeople;
  var hasTitles = title || subtitle || pretitle;
  var siteLinks = sites.map(function (site) {
    return {
      id: "site-".concat(site.id),
      url: "".concat(site.url).concat(path),
      name: 'View page on website',
      __typename: 'Link'
    };
  });
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    asideRatio: 2 / 7,
    space: 0,
    main: react_1.default.createElement(My.Main, null, mainHeader, hasTitles && react_1.default.createElement(My.Titles, null, pretitle && react_1.default.createElement(My.Pretitle, null, react_1.default.createElement(markdown_1.Markdown, {
      text: pretitle
    })), title && react_1.default.createElement(My.Title, null, react_1.default.createElement(markdown_1.Markdown, {
      text: title
    })), subtitle && react_1.default.createElement(My.Subtitle, null, react_1.default.createElement(markdown_1.Markdown, {
      text: subtitle
    }))), intro && react_1.default.createElement(My.Intro, {
      entity: intro
    }), content && react_1.default.createElement(My.Content, {
      entity: content
    }), outro && react_1.default.createElement(My.Outro, {
      entity: outro
    }), react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: files,
      maxItems: 3
    }), hasSlices && slices.map(function (slice, index) {
      return react_1.default.createElement(My.Slice, {
        key: slice.id,
        number: index + 1,
        entity: slice
      });
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: sites,
      title: ""
    }), hasType && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Value, {
      entity: type
    })), hasLayout && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Value, {
      entity: layout
    })), parent && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.LinkValue, {
      entity: parent,
      label: "Parent {{PAGE}}:"
    })), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: children,
      title: "Child {{PAGES}}:"
    }), react_1.default.createElement(My.ListSection, {
      title: "",
      useLinks: false,
      maxItems: 4,
      items: siteLinks,
      rowComponent: link_value_1.LinkValue
    }), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: featurePages,
      title: "Feature {{PAGES}}:"
    }), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: marqueePages,
      title: "Marquee {{PAGES}}:"
    }), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: people
    }), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: authors,
      title: "Authors:"
    }), asideFooter)
  }));
};
exports.PageDetailsLayout = PageDetailsLayout;
exports.PageDetailsLayout.defaultProps = exports.PageDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45;